import { useAppDispatch, useAppSelector } from '@hooks/redux-custom';
import { useCustomer } from '@hooks/useCustomer';
import { useIsCustomerVerifiedMutation } from '@services';
import { setCustomerVerification } from '@store/slices/customer';
import { useCallback, useEffect, useMemo } from 'react';

type CustomerVerificationType = {
  verified: boolean;
  checkVerificationStatus: () => void;
};

export const useCustomerVerification = (): CustomerVerificationType => {
  const { verified } = useAppSelector((state) => state.customer.value);

  const dispatch = useAppDispatch();
  const { customer } = useCustomer();
  const [isCustomerVerified] = useIsCustomerVerifiedMutation();

  const checkVerificationStatus = useCallback(() => {
    isCustomerVerified({ userId: customer.id })
      .unwrap()
      .then((res) => {
        if (res.data) {
          dispatch(setCustomerVerification(res.data));
        }
      });
  }, [customer.id, dispatch, isCustomerVerified]);

  useEffect(() => {
    checkVerificationStatus();
  }, [checkVerificationStatus, customer]);

  const customerVerification = useMemo(() => ({ verified, checkVerificationStatus }), [verified, checkVerificationStatus]);

  return customerVerification;
};
